if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        openBtn: document.querySelector('a.header__icon--cart'),
        closeBtn: this.querySelector('.cart-drawer__header-close'),
        drawer: this
      };

      const openBtn = this.selectors.openBtn;

      // Close drawer when clicked outside.
      document.addEventListener("click", function (event) {
        const cartDrawer = document.getElementById("cart-drawer");
        const vvSuperCrosscartDrawer = document.getElementById("vv-super-cross-cart-drawer");

        if (cartDrawer && !cartDrawer.contains(event.target) && (!vvSuperCrosscartDrawer || !vvSuperCrosscartDrawer.contains(event.target)) && !openBtn.contains(event.target)) {
          document.body.classList.remove("drawer-open");
          cartDrawer.classList.remove("is-expanded");
        }
      });

      // Close drawer on ESC.
      document.addEventListener('keydown', function(event) {
        const isDrawerOpen = document.body.classList.contains('drawer-open') || false;
        if (isDrawerOpen) {
          if (event.key === 'Escape' || event.keyCode === 27) {
            document.body.classList.remove("drawer-open");
            document.getElementById("cart-drawer")?.classList.remove("is-expanded");
          }
        }
      });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('vv-super-cross-cart-drawer')) {
  class VvSuperCrossCartDrawer extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        openBtn: document.querySelector('a.header__icon--cart'),
        closeBtn: this.querySelector('.cart-drawer__header-close'),
        drawer: this
      };

      const openBtn = this.selectors.openBtn;

      // Close drawer when clicked outside.
      document.addEventListener("click", function (event) {
        const vvSuperCrosscartDrawer = document.getElementById("vv-super-cross-cart-drawer");
        const cartDrawer = document.getElementById("cart-drawer");

        if (vvSuperCrosscartDrawer && !vvSuperCrosscartDrawer.contains(event.target) && (!cartDrawer || !cartDrawer.contains(event.target)) && !openBtn.contains(event.target)) {
          document.body.classList.remove("drawer-open");
          vvSuperCrosscartDrawer.classList.remove("is-expanded");
        }
      });

      // Close drawer on ESC.
      document.addEventListener('keydown', function(event) {
        const isDrawerOpen = document.body.classList.contains('drawer-open') || false;
        if (isDrawerOpen) {
          if (event.key === 'Escape' || event.keyCode === 27) {
            document.body.classList.remove("drawer-open");
            document.getElementById("vv-super-cross-cart-drawer")?.classList.remove("is-expanded");
          }
        }
      });
    }
  }
  customElements.define('vv-super-cross-cart-drawer', VvSuperCrossCartDrawer);
}
